<sb-card [loading]="!loading" [loadingDelay]="1" [halfHeight]="halfHeight">
  <div card-header>
    <h1>{{'lang.dashboard.services' | translate}}</h1>
    <small>{{ 'lang.globals.betweenCountDays' | translate: {count: timespan ? timespan?.days : ' - '} }}</small>
  </div>
  <div card-header-more>
    <div class="font-weight-normal text-end" style="font-size: 12px" #chartLegend></div>
  </div>
  <sb-chart #chart chartType="lineChart" card-body [chartData]="serviceData"></sb-chart>
</sb-card>
